const AcademicSchedule = () => {
    return (
        <div id="timing" className="vision-card">
            <h3>ACADEMIC SCHEDULE</h3>

            <div className="schedule-wrapper">
                <div className="schedule-header">
                    <h2>NAV JEEVAN MISSION SCHOOL</h2>

                    <h4>TIME TABLE</h4>
                </div>

                {/* <table className="modern-schedule-table">
                    <thead>
                        <tr>
                            <th>TIME</th>
                            <th>ACTIVITY</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>08:00 AM</td>
                            <td>🔔 Long Bell</td>
                        </tr>

                        <tr>
                            <td>08:00 AM - 08:20 AM</td>
                            <td>🙏 Prayer</td>
                        </tr>

                        <tr>
                            <td>08:20 AM - 08:55 AM</td>
                            <td>1st Period</td>
                        </tr>

                        <tr>
                            <td>08:55 AM - 09:25 AM</td>
                            <td>2nd Period</td>
                        </tr>

                        <tr>
                            <td>09:25 AM - 09:55 AM</td>
                            <td>3rd Period</td>
                        </tr>

                        <tr>
                            <td>09:55 AM - 10:25 AM</td>
                            <td>4th Period</td>
                        </tr>

                        <tr className="lunch-row">
                            <td>10:25 AM - 10:50 AM</td>
                            <td>🍴 Lunch Break</td>
                        </tr>

                        <tr>
                            <td>10:50 AM - 11:25 AM</td>
                            <td>5th Period</td>
                        </tr>

                        <tr>
                            <td>11:25 AM - 11:55 AM</td>
                            <td>6th Period</td>
                        </tr>

                        <tr>
                            <td>11:55 AM - 12:30 PM</td>
                            <td>7th Period</td>
                        </tr>

                        <tr>
                            <td>12:30 PM - 01:00 PM</td>
                            <td>8th Period</td>
                        </tr>
                    </tbody>
                </table> */}
            </div>
        </div>
    );
};

export default AcademicSchedule;